import CommonPropertiesWithGeometry from "./commonPropertiesWithGeometry";
class GroupNodeSourceAdditionalInfo extends CommonPropertiesWithGeometry {
    constructor(DocumentObjects, Created, Description, Color, NodeWidth, NodeHeight) {
        super(Created, Description, Color, NodeWidth, NodeHeight);
        this.DocumentObjects = DocumentObjects;
    }
}
export default GroupNodeSourceAdditionalInfo;
